//FB 7969 - Added required imports
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Link, Typography } from "@mui/material";
import PrivacyPolicy from "../feature/User/Policies/PrivacyPolicy";
import { useState } from "react";
import UseStyle from "../css/styles";

// Update log
// FB  6192   02/06/2023  DK   Added page to habdle footer to be displayed
// FB  7405   09/21/2023  SK   Orady - Portal changes
// FB  7469   09/27/2023  SK   Patient Portal - Replace Doctor Direct with License Name , Update logo in Payment Receipt , Change in texts in Home Page
// FB  7512   10/03/2023  GA   Orady - supress footer links
// FB  7969   12/20/2023  DK   Add privacy policy link and content on Portal

function Footer() {
  const styles = UseStyle();
  const footerLinks = [
    "Privacy and Cookies",
    "Sitemap",
    "Accessibility",
    "Legal notices",
    //FB 7405 - Removed Unused Part of Code
    "Contact us",
  ];
  const [open, setOpen] = useState(false);  //FB 7969

  //FB 7469 - Begin
  function Footerlinks() {
    return (
      <Typography
        variant="body2"
        align="left"
        style={{
          paddingTop: "32px",
          paddingLeft: window.innerWidth < 768 ? "16px" : "80px",
        }}>
        {/* FB 7969 - Start*/}
        <Button style={{ color: "white", textTransform: "capitalize" }} onClick={() => setOpen(true)}>Privacy and Cookies</Button>
        {/* <Link color="inherit" onClick={() => setOpen(true)} style={{ marginRight: '15px' }}>
          Privacy and Cookies
        </Link>{" "} */}
        {/* <Link color="inherit" href="/" style={{ marginRight: '15px' }}>
          Accessibility
        </Link>
        {" "}
        <Link color="inherit" href="/" style={{ marginRight: '15px' }}>
          Legal notices
        </Link>{"  "}
        <Link color="inherit" href="/">
          Contact us
        </Link>{" "} */}
        {/* FB 7969 - End*/}
      </Typography>
    );
  }
  //FB 7469 - End

  function Terms() {
    return (
      <Typography
        variant="body2"
        align="left"
        style={{
          paddingTop: "32px",
          paddingLeft: window.innerWidth < 768 ? "16px" : "80px",
        }}
      >
        {"This site is for informational purposes only, view our "}
        {/* FB 7969 */}
        <Link color="inherit" href="/privacypolicy">
          PRIVACY POLICY
        </Link>{" "}
        {". For full disclaimer "}
        <Link color="inherit" href="https://material-ui.cm/">
          click here
        </Link>{" "}
        {". "}
        <Link color="inherit" href="https://material-ui.cm/">
          TERMS OF USE
        </Link>{" "}
        {". Read our "}
        <Link color="inherit" href="https://material-ui.cm/">
          ACCESSIBILITY STATEMENT
        </Link>{" "}
      </Typography>
    );
  }
  function Copyright() {
    return (
      <Typography
        variant="body2"
        align="left"
        style={{
          paddingTop: "12px",
          paddingLeft: window.innerWidth < 768 ? "16px" : "80px",
        }}
      >
        {"© "}
        <Link color="inherit" href="https://material-ui.cm/">
          Doctor Direct, P.C. All Rights Reserved
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
      </Typography>
    );
  }

  return (
    <footer className={styles.Footer}>
      <Box>
        {/* FB 7469 - Commented Unused Part of Code - Begin*/}
        {/* <Grid container spacing={2} className={styles.d_flex}>
          {footerLinks.map((link) => (
            <Grid item>{link}</Grid>
          ))}
        </Grid> */}
        {/* FB 7512 Begin- Commented out the following footer links */}
        {/* FB 7969 */}
        <Footerlinks />
        {/* FB 7469 - End*/}
        {/* <Terms /> */}
        {/* <Copyright /> */}
        {/* FB 7512 End */}
      </Box>
      {/* FB 7969 */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth={"lg"}>
        <DialogTitle>
          <Grid item xs={12} style={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
            <Typography variant="h6" style={{ color: "#083A4D" }}>
              <br /><b>Privacy Policy for Patient Portal</b>
            </Typography>
          </Grid>
        </DialogTitle>
        <DialogContent
          style={{
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <PrivacyPolicy />
        </DialogContent>
        <DialogActions>
          <Button
            className={styles.textbutton}
            onClick={() => setOpen(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </footer>
  );
}

export default Footer;
